import React, { useState } from "react";
import type { DiffWBSNode } from "../../../models";
import "./DiffSidebarNode.css";

interface Props {
  node: DiffWBSNode;
  depth: number;
  onNavigate: (node: DiffWBSNode) => void;
}

const FolderIcon = () => (
  <svg className="diff-sidebar-node__icon" width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
    <path d="M1.75 1A1.75 1.75 0 0 0 0 2.75v10.5C0 14.216.784 15 1.75 15h12.5A1.75 1.75 0 0 0 16 13.25v-8.5A1.75 1.75 0 0 0 14.25 3H7.5a.25.25 0 0 1-.2-.1l-.9-1.2C6.07 1.26 5.55 1 5 1H1.75Z" />
  </svg>
);

const FileIcon = () => (
  <svg className="diff-sidebar-node__icon" width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
    <path d="M2 1.75C2 .784 2.784 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V6h-2.75A1.75 1.75 0 0 1 9 4.25V1.5Zm6.75.062V4.25c0 .138.112.25.25.25h2.688l-.011-.013-2.914-2.914-.013-.011Z" />
  </svg>
);

const DiffSidebarNode: React.FC<Props> = ({ node, depth, onNavigate }) => {
  const [expanded, setExpanded] = useState(true);
  const hasChildren = node.children.length > 0;

  const added = node.activities.filter((a) => a.type === "added").length;
  const changed = node.activities.filter((a) => a.type === "changed").length;
  const removed = node.activities.filter((a) => a.type === "removed").length;

  return (
    <>
      <button
        className={`diff-sidebar-node diff-sidebar-node--${node.node_status}`}
        style={{ paddingLeft: `${depth * 16 + 8}px` }}
        onClick={() => onNavigate(node)}
        title={node.name}
      >
        <span
          className={`diff-sidebar-node__chevron${expanded ? " diff-sidebar-node__chevron--expanded" : ""}${!hasChildren ? " diff-sidebar-node__chevron--hidden" : ""}`}
          onClick={(e) => {
            if (hasChildren) {
              e.stopPropagation();
              setExpanded((prev) => !prev);
            }
          }}
          dangerouslySetInnerHTML={{ __html: "&#9654;" }}
        />
        {hasChildren ? <FolderIcon /> : <FileIcon />}
        <span className="diff-sidebar-node__name">{node.name}</span>
        <span className="diff-sidebar-node__pills">
          {added > 0 && <span className="diff-pill diff-pill--added">+{added}</span>}
          {changed > 0 && <span className="diff-pill diff-pill--changed">{changed}</span>}
          {removed > 0 && <span className="diff-pill diff-pill--removed">-{removed}</span>}
        </span>
      </button>
      {expanded && node.children.map((child) => (
        <DiffSidebarNode
          key={child.wbs_path}
          node={child}
          depth={depth + 1}
          onNavigate={onNavigate}
        />
      ))}
    </>
  );
};

export default DiffSidebarNode;
